import router from '@/router'
import { getUserAuth } from '@/api/modules/menu'
import {
    lazyLoading,
    initRoutes,
    addRoutes,
    addActualRoutes
} from '@/utils/tools.js'

const state = {
    activeTab: '', // 当前选中的 tab
    tabsList: [], // 选项卡数组
    activeRoutes: [],   // 动态返回的路由列表
    routeList: [],  // 路由提取到一级的数组集合
    roleBtns: [],   // 权限按钮组
}

const mutations = {
    SET_TABS_LIST(state, arr) {
        state.tabsList = arr
    },
    SET_ACTIVE_TAB(state, name) {
        state.activeTab = name
    },
    SET_AVTIVE_ROUTES(state, routes) {
        state.activeRoutes = routes
    },
    SET_ROUTE_LIST(state, list) {
        state.routeList = list
    },
    SET_ROLE_BTNS(state, path) {
        state.roleBtns = []
        let _item = state.routeList.find(x => x.path === path)

        if (_item) {
            state.roleBtns = _item.buttons ? _item.buttons.map(y => y.alias) : []
        }
    }
}

const actions = {
    // 设置 tabs 
    setTabsList: ({ commit }, arr) => {
        commit('SET_TABS_LIST', arr)
    },

    // 设置当前选中的 tab
    setActiveTab: ({ commit }, name) => {
        commit('SET_ACTIVE_TAB', name)
    },

    // 获取返回的菜单路由
    setMenuList: ({ commit }, token) => {
        let resArr = []
        // 添加父级
        resArr.push({
            id: '0',
            parentId: 'root',
            path: '/main',
            name: 'Main',
            meta: {
                title: '首页',
            },
            redirect: '/home',
            parentName: 'root',
            component: lazyLoading('layout/index'),
            children: []
        })
        return new Promise((resolve, reject) => {
            getUserAuth({token: token}).then(res => {
                const { data } = res

                if (data.length === 0) {
                    reject('还账号无角色菜单，请配置后登录')
                }

                // 把返回的数组 处理成 项目需要的组件数据
                resArr[0].children = addActualRoutes(resArr[0].children, data)
                resArr[0].redirect = resArr[0].children[0].path
                let routeList = initRoutes(resArr, 'parentId')
                // console.log(resArr)
                // console.log(routeList)
                
                commit('SET_AVTIVE_ROUTES', resArr)
                commit('SET_ROUTE_LIST', routeList)

                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },

    // 根据角色返回的菜单 渲染路由
    setActiveRoutes: ({ commit }, arr) => {
        let resArr = []
        let routes = addRoutes(resArr, arr)
        let routeList = initRoutes(arr)

        commit('SET_AVTIVE_ROUTES', routes)
        commit('SET_ROUTE_LIST', routeList)
    },

    // 设置当前路由的按钮权限组
    setRoleBtns: ({ commit }, path) => {
        commit('SET_ROLE_BTNS', path)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}